import { render } from "./PetsTable.vue?vue&type=template&id=4294319c&ts=true"
import script from "./PetsTable.vue?vue&type=script&lang=ts"
export * from "./PetsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__